// extracted by mini-css-extract-plugin
module.exports = {"control":"ProjectSliderControl_control__ZxDV9","leftControl":"ProjectSliderControl_leftControl__MH4Eg","rightControl":"ProjectSliderControl_rightControl__fDEpt"};